import React, { useState, useEffect } from "react";
import { Container, Row, Col, Modal, Button } from "react-bootstrap";
import ImageGallery1 from "../assets/collection/1.jpeg";
import ImageGallery2 from "../assets/collection/2.jpeg";
import ImageGallery3 from "../assets/collection/3.jpeg";
import ImageGallery4 from "../assets/collection/4.jpeg";
import ImageGallery5 from "../assets/collection/5.jpeg";
import ImageGallery6 from "../assets/collection/6.jpeg";
import ImageGallery8 from "../assets/collection/8.jpeg";
import ImageGallery9 from "../assets/collection/9.jpeg";
import ImageGallery11 from "../assets/collection/11.jpeg";
import ImageGallery12 from "../assets/collection/12.jpeg";
import ImageGallery13 from "../assets/collection/19.jpeg";
import ImageGallery15 from "../assets/collection/15.jpeg";
import ImageGallery16 from "../assets/collection/16.jpeg";
import ImageGallery17 from "../assets/collection/17.jpeg";
import ImageGallery18 from "../assets/collection/18.jpeg";
import ImageGallery19 from "../assets/collection/13.jpeg";
import ImageGallery20 from "../assets/collection/20.jpeg";

import Navbar1 from "./Navbar";

const Collection = () => {
  const [selectedItem, setSelectedItem] = useState(null);
  const [showModal, setShowModal] = useState(false);

  // Scrolla la pagina verso l'alto quando il componente viene montato
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, []);

  const handleItemClick = (item) => {
    setSelectedItem(item);
    setShowModal(true);
  };

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.1,
      }
    );

    document.querySelectorAll(".gallery-item").forEach((item) => {
      observer.observe(item);
    });

    return () => observer.disconnect();
  }, []);

  return (
    <>
      <Navbar1 />

      <section className="photo-gallery py-5" style={{ marginTop: "30px" }}>
        <Container className="mt-4 mb-4">
          <Row>
            {[
              {
                image: ImageGallery1,
                description:
                  "Orecchini in oro bianco e peridoti - Orecchini in oro bianco 18kt con peridoto taglio tondo di 0,97 carati proveniente dal Brasile. Peso totale 1,73 grammi.",
                price: "€351",
                ebayLink:
                  "https://www.ebay.it/itm/356152401822?_skw=starblack+gioielli&itmmeta=01JA85TFRSQYEEH34F6KVGNXB6&hash=item52ec565f9e:g:t3oAAOSwhTpnDkcm&itmprp=enc%3AAQAJAAAA0HoV3kP08IDx%2BKZ9MfhVJKkdrsA2%2FX%2FOyhmWckpdXdAqQDzqSX306a%2FlSnP7Iu9aojbZ%2BAqpuPuJBRChpNFNXA4kdE1jfCtUcfniVuAIP4jbNZamJ%2Fxn%2Bzu%2BbdXQxtxYUKb%2FpCQvd8JV5SptXa18fU1lbgYQ%2B4xQ8%2F91MYHANl9KtduxfCu9yx1xxh8fZj%2Fd%2Bq2tbbnykPtmZe9KoyBXMzw3sw4N5aPq1QlWuZredvXmpNeImYGNDZFmidV7T6eYD4cKA4sH6v7KSca%2FyCDWhWk%3D%7Ctkp%3ABk9SR7j86YXSZA",
              },
              {
                image: ImageGallery2,
                description:
                  "Collana punto luce in oro bianco con diamante - Collana punto luce in oro bianco con diamante per un gioiello senza tempo che farà sentire chi lo indosserà una donna di classe, elegante e grintosa.",
                price: "€171",
                ebayLink:
                  "https://www.ebay.it/itm/356152924809?itmmeta=01JA8A132V8HXB46H48ZKT2M0C&hash=item52ec5e5a89%3Ag%3AJU0AAOSwJQZnDn2v&LH_All=1",
              },
              {
                image: ImageGallery3,
                description:
                  "Anello in argento rodiato con Zirconi che si distingue per la sua personalità e versalità.",
                price: "€122",
                ebayLink:
                  "https://www.ebay.it/itm/356153258067?mkcid=16&mkevt=1&mkrid=711-127632-2357-0&ssspo=fty_md8uqkw&sssrc=2047675&ssuid=fty_md8uqkw&widget_ver=artemis&media=COPY",
              },
              {
                image: ImageGallery4,
                description: "Anello per lui: in fascia d'argento, misura modificabile.",
                price: "€108",
                ebayLink:
                  "https://www.ebay.it/itm/356153277383?mkcid=16&mkevt=1&mkrid=711-127632-2357-0&ssspo=fty_md8uqkw&sssrc=2047675&ssuid=fty_md8uqkw&widget_ver=artemis&media=COPY",
              },
              {
                image: ImageGallery5,
                description:
                  "Anello dal colore unico e brillante, indossandolo potrai brillare di una nuova energia, ossia quella regalata dallo splendido peridoto che lo impreziosisce. Dettagli: anello in oro bianco 18 kt con peridoto da 0,97 carati. Lavorazione artigianale.",
                price: "€1.020,00",
                ebayLink:
                  "https://www.ebay.it/itm/356153301655?mkcid=16&mkevt=1&mkrid=711-127632-2357-0&ssspo=fty_md8uqkw&sssrc=2047675&ssuid=fty_md8uqkw&widget_ver=artemis&media=COPY",
              },
              {
                image: ImageGallery6,
                description: "Anello in oro bianco con Topazio, colore argento e regolabile.",
                price: "€432",
                ebayLink:
                  "https://www.ebay.it/itm/356153420369?mkcid=16&mkevt=1&mkrid=711-127632-2357-0&ssspo=fty_md8uqkw&sssrc=2047675&ssuid=fty_md8uqkw&widget_ver=artemis&media=COPY",
              },
              {
                image: ImageGallery8,
                description: "Anello triplo in argento 925 misura 15 peso totale di 13,5 grammi.",
                price: "€89",
                ebayLink:
                  "https://www.ebay.it/itm/356153458595?mkcid=16&mkevt=1&mkrid=711-127632-2357-0&ssspo=fty_md8uqkw&sssrc=2047675&ssuid=fty_md8uqkw&widget_ver=artemis&media=COPY",
              },
              {
                image: ImageGallery9,
                description:
                  "Anello in oro realizzato a mano e impreziosito con del quarzo citrino, come simbolo della forza del legame che unisce un sentimento d'amore.",
                price: "€875",
                ebayLink:
                  "https://www.ebay.it/itm/356153486069?mkcid=16&mkevt=1&mkrid=711-127632-2357-0&ssspo=fty_md8uqkw&sssrc=2047675&ssuid=fty_md8uqkw&widget_ver=artemis&media=COPY",
              },
              {
                image: ImageGallery11,
                description:
                  "Anello in argento 925 con topazio naturale di 1,13 carati e diamanti naturali incolori taglio brillante F-G e purezza VS",
                price: "€152,98",
                ebayLink:
                  "https://www.ebay.it/itm/356154013819?mkcid=16&mkevt=1&mkrid=711-127632-2357-0&ssspo=fty_md8uqkw&sssrc=2047675&ssuid=fty_md8uqkw&widget_ver=artemis&media=COPY",
              },
              {
                image: ImageGallery12,
                description: "Anello da donna in argento 925, misura 15",
                price: "€108",
                ebayLink:
                  "https://www.ebay.it/itm/356154024321?mkcid=16&mkevt=1&mkrid=711-127632-2357-0&ssspo=fty_md8uqkw&sssrc=2047675&ssuid=fty_md8uqkw&widget_ver=artemis&media=COPY",
              },
              {
                image: ImageGallery13,
                description:
                  "Orecchini in oro bianco Made in Italy , 18kt con diamanti e ioliti certificati. Peso totale 4,03 grammi.",
                price: "€313,00",
                ebayLink:
                  "https://www.ebay.it/itm/356154035773?mkcid=16&mkevt=1&mkrid=711-127632-2357-0&ssspo=fty_md8uqkw&sssrc=2047675&ssuid=fty_md8uqkw&widget_ver=artemis&media=COPY",
              },
              {
                image: ImageGallery15,
                description: "Anello in argento rodiato satinato e onice taglio cabochon",
                price: "€119",
                ebayLink:
                  "https://www.ebay.it/itm/356154051071?mkcid=16&mkevt=1&mkrid=711-127632-2357-0&ssspo=fty_md8uqkw&sssrc=2047675&ssuid=fty_md8uqkw&widget_ver=artemis&media=COPY",
              },
              {
                image: ImageGallery16,
                description: "Anello in argento rodiato 925 con quarzo fumè, taglio smeraldo",
                price: "€162",
                ebayLink:
                  "https://www.ebay.it/itm/356154061627?mkcid=16&mkevt=1&mkrid=711-127632-2357-0&ssspo=fty_md8uqkw&sssrc=2047675&ssuid=fty_md8uqkw&widget_ver=artemis&media=COPY",
              },
              {
                image: ImageGallery17,
                description: "Catenina in oro bianco con ciondolo in iolite e diamante",
                price: "€270",
                ebayLink:
                  "https://www.ebay.it/itm/356154080958?mkcid=16&mkevt=1&mkrid=711-127632-2357-0&ssspo=fty_md8uqkw&sssrc=2047675&ssuid=fty_md8uqkw&widget_ver=artemis&media=COPY",
              },
              {
                image: ImageGallery18,
                description:
                  "Orecchini a forma di fiori impreziositi con del zaffiro blu, pietra conosciuta sin dall'antichità. Fai fiorire il tuo stile!",
                price: "€200",
                ebayLink:
                  "https://www.ebay.it/itm/356155926544?mkcid=16&mkevt=1&mkrid=711-127632-2357-0&ssspo=fty_md8uqkw&sssrc=2047675&ssuid=fty_md8uqkw&widget_ver=artemis&media=COPY",
              },
              {
                image: ImageGallery19,
                description:
                  "Anello in oro bianco 18 carati di 2,7 grammi con sei diamanti taglio brillante per un totale di 0,1 carati e quarzo citrino lemon, taglio a goccia di un carato",
                price: "€1.070",
                ebayLink:
                  "https://www.ebay.it/itm/356155936207?mkcid=16&mkevt=1&mkrid=711-127632-2357-0&ssspo=fty_md8uqkw&sssrc=2047675&ssuid=fty_md8uqkw&widget_ver=artemis&media=COPY",
              },
              {
                image: ImageGallery20,
                description:
                  "Anello in oro con smeraldo naturale di Starblack Gioielli, un gioiello senza tempo che si adatta a ogni stagione e qualsiasi occasione. Per una donna che non ama farsi trovare impreparata, ma desidera essere sempre pronta per affrontare nuove avventure.",
                price: "€585,00",
                ebayLink:
                  "https://www.ebay.it/itm/356155942808?mkcid=16&mkevt=1&mkrid=711-127632-2357-0&ssspo=fty_md8uqkw&sssrc=2047675&ssuid=fty_md8uqkw&widget_ver=artemis&media=COPY",
              },
            ].map((item, index) => (
              <Col key={index} xs={12} sm={6} md={3} className="mb-4">
                <div className="gallery-item" onClick={() => handleItemClick(item)}>
                  <img src={item.image} alt={`Gallery ${index + 1}`} className="gallery-image" />
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Descrizione del Gioiello</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedItem && (
            <>
              <img src={selectedItem.image} alt="Selected" className="img-fluid mb-3" />
              <p>{selectedItem.description}</p>
              <p>
                <strong>Prezzo: {selectedItem.price}</strong>
              </p>

              {/* Aggiungi il bottone per acquistare il prodotto su Ecwid */}
              <Button
                variant="primary"
                onClick={() => window.open(selectedItem.ebayLink, "_blank")}
                style={{ backgroundColor: "black", borderColor: "black" }}
              >
                Acquista
              </Button>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Chiudi
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Collection;
